import './ConfirmationToast.scss';

const ConfirmationToast = ({text, onConfirm}) => {
    return (
        <div className="confirmation-toast">
            <div>{text}</div>
            <div>
                <button className="confirmation-toast__button" onClick={onConfirm}>Yes</button>
                <button className="confirmation-toast__button">No</button>
            </div>
        </div>
    );
};

export default ConfirmationToast;